import { allowedSelectCoverPlatforms } from "features/post/const";

export { allowedSelectCoverPlatforms };
// Keep this upload list in sync with @dialogueconsulting/sked-preview.
export const allowedUploadCoverPlatforms = ["IG", "FB", "LI"] as const;
// Keep the 10-frame selector close to the old 8-frame total width
// so opening cover selection doesn't push the preview column.
export const THUMBNAIL_WIDTH = 52;
export const THUMBNAIL_HEIGHT = 91;

export const allowedPlatformFullnameMapping: Record<string, string> = {
  TT: "Tiktok",
  IG: "Instagram",
  FB: "Facebook",
  LI: "LinkedIn",
};
